import { useTranslations } from 'next-intl';
import { useStats } from 'react-instantsearch';

import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';

/**
 * SearchStats component for the Algolia search block.
 *
 * @see https://www.algolia.com/doc/api-reference/widgets/stats/react/
 */

const SearchStats = () => {
  const t = useTranslations('search');
  const { nbHits, hitsPerPage, page } = useStats();

  if (nbHits === 0 || !hitsPerPage) {
    return null;
  }

  const start = page * hitsPerPage + 1;
  const end = Math.min((page + 1) * hitsPerPage, nbHits);

  return (
    <Flex gap="xxs" align="center">
      <Text as="span" level="body-xs" transform="uppercase" marginBottom="none">
        {t('results')}
      </Text>
      <Text as="span" level="body-xs" weight="medium" transform="uppercase" marginBottom="none">
        {t('stats', { start, end, total: nbHits })}
      </Text>
    </Flex>
  );
};

export default SearchStats;
